import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ModalContext, AlloyButton } from 'cat-ecommerce-alloy';
import ContactUsOptions from '../../../../../common/ContactUsOptions';
import CartImportSummaryTable from '../CartImportSummaryTable';
import CartImportSummaryItemsNotAdded from '../CartImportSummaryItemsNotAdded';
import CartImportSummaryItemsReplaced from '../CartImportSummaryItemsReplaced';
import styles from './styles.module.scss';

const CartImportSummaryModal = () => {
  const { t } = useTranslation();
  const modalCtx = useContext(ModalContext);
  const {
    itemsNotAdd,
    replacedPartList,
    totalItemsAdded,
    totalItemsRequested
  } = useSelector(state => state.checkout.deepLink);

  const replaceShoppingCartLink = msg => {
    const msgSplit = msg.split('{0}');
    return (
      <span className={`${styles['cart-import-summary__text']}`}>
        {msgSplit[0]}
        <AlloyButton
          buttonType="link"
          size="large"
          className="p-0 pe-1 text-lowercase"
          data-testid="shoppingCartLink"
          onClick={modalCtx.removeCurrentModal}
        >
          {t('SHOPPINGCART_TITLE')}.
        </AlloyButton>
      </span>
    );
  };

  return (
    <div className={`${styles['cart-import-summary__container']}`}>
      <h2 className="text-uppercase">{t('CART_IMPORT_MODAL_TITLE')}</h2>
      <div className={styles['cart-import-summary__horizontal-rule']}></div>
      <p className="mt-3 mb-3">
        <span className={`${styles['cart-import-summary__text']}`}>
          {t('CART_IMPORT_MODAL_MSG1')}
        </span>
        {replaceShoppingCartLink(t('CART_IMPORT_MODAL_MSG2'))}
        <span className={`${styles['cart-import-summary__text']}`}>
          {t('CART_IMPORT_MODAL_MSG3')}
        </span>
      </p>
      <CartImportSummaryTable
        totalItemsAdded={totalItemsAdded}
        totalItemsRequested={totalItemsRequested}
      />
      {itemsNotAdd?.length > 0 && (
        <CartImportSummaryItemsNotAdded itemsNotAdd={itemsNotAdd} />
      )}
      {replacedPartList?.length > 0 && (
        <CartImportSummaryItemsReplaced replacedPartList={replacedPartList} />
      )}
      <div className="text-center mb-4">
        <AlloyButton
          buttonType="secondary"
          size="large"
          onClick={modalCtx.removeCurrentModal}
        >
          {t('CART_IMPORT_MODAL_PROCEED')}
        </AlloyButton>
      </div>
      <div className="fw-bold">
        <ContactUsOptions />
      </div>
    </div>
  );
};

export default CartImportSummaryModal;
